<template>
  <div>
    <el-form-item label="流向:"  class="shengSX" prop="mapShengShiQu">
      <el-input  placeholder=""   v-model="addFrom.mapShengShiQu" :readonly="true"></el-input>
    </el-form-item>
    <el-form-item label="备注:" class="shengSX" prop="remark">
      <el-input v-model="addFrom.remark" :readonly="false"></el-input>
    </el-form-item>
    <el-form-item label="详细地址:"  class="bigInp" prop="address">
         <el-input  placeholder="" maxlength="100"  v-model="addFrom.address" :readonly="false"></el-input>
    </el-form-item>
    <div class="mapBox">
       <el-amap
      vid="amapDemo"
      :center="mapCenter"
      :zoom="12"
      class="amap-demo"
      :events="events">
      <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position" :events="marker.events" :visible="true"  :vid="index"></el-amap-marker>
    </el-amap>
     <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
    </div>

  </div>
  </template>
<script>
import { bAreasList } from '@/api/common'
export default {
  name: 'mapAddress',
  props: {
    addFrom: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    let self = this
    return {
      // 地图
      mapMark: false,
      markers: [],
      searchOption: {
        city: '中国',
        citylimit: false
      },
      mapCenter: [116.397428, 39.90923],
      address: '',
      events: {
        click (e) {
          // console.log(e, '04')
          let { lng, lat } = e.lnglat
          self.addFrom.longitude = lng
          self.addFrom.latitude = lat
          // 这里通过高德 SDK 完成。
          // eslint-disable-next-line no-undef
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })
          geocoder.getAddress([lng, lat], function (status, result) {
            self.getAddre(status, result, lng, lat, self)
          })
        },
        // 搜索
        souSuo (pois) {
          // console.log(pois, '03')
          let lng = pois[0].lng
          let lat = pois[0].lat
          self.addFrom.longitude = lng
          self.addFrom.latitude = lat
          // 这里通过高德 SDK 完成。
          // eslint-disable-next-line no-undef
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })
          self.markers = []
          geocoder.getAddress([lng, lat], function (status, result) {
            self.getAddre(status, result, lng, lat, self)
          })
        }
      }
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.addFrom, 'address', this.addFrom.address)
    if (this.addFrom.provinceName) {
      this.$set(this.addFrom, 'mapShengShiQu', this.addFrom.provinceName + '-' + this.addFrom.cityName + '-' + this.addFrom.areaName)
      if (this.addFrom.longitude && this.addFrom.latitude) {
        this.mapCenter = [this.addFrom.longitude, this.addFrom.latitude]
        this.markers.push({ 'position': [this.addFrom.longitude, this.addFrom.latitude] })
      }
    }
  },
  methods: {
    onSearchResult (pois) {
      // console.log(pois, '01')
      this.events.souSuo(pois)
    },
    // 获取地址
    getAddre (status, result, lng, lat, self) {
      // console.log(status, '02')
      if (status === 'complete' && result.info === 'OK') {
        if (result && result.regeocode) {
          // console.log(result,'////////')
          self.markers = [{ 'position': [lng, lat],
            'events': {
              click: () => {
                // console.log(result.regeocode, '111111')
                self.$set(self.addFrom, 'getAddress', result.regeocode.formattedAddress)
                self.$set(self.addFrom, 'longitude', lng)
                self.$set(self.addFrom, 'latitude', lat)
              }
            } }]
          // console.log(this.markers,'888888')
          self.mapCenter = [lng, lat]
          self.mapSheng = result.regeocode.addressComponent.province // 省
          self.mapShi = result.regeocode.addressComponent.city // 市
          console.log(result, 'result')
          if (self.mapShi == '') {
            self.mapShi = self.mapSheng
          }
          self.mapQu = result.regeocode.addressComponent.district // 区
          // if (self.mapQu == '') {
          //   self.mapQu = result.regeocode.addressComponent.township
          // }
          self.mapJieDao = result.regeocode.addressComponent.township // 街道
          self.mapLu = result.regeocode.addressComponent.street // 路
          self.mapHao = result.regeocode.addressComponent.streetNumber // 门牌号
          self.mapdiZhiName = result.regeocode.pois[0].name // 地址名
          self.mapXiaoQu = result.regeocode.addressComponent.neighborhood // 小区
          self.building = result.regeocode.addressComponent.building // 建筑物
          self.addFrom.address = result.regeocode.formattedAddress
          // console.log(self.mapSheng+self.mapShi+self.mapQu)
          if (self.mapQu == '') {
            self.$set(self.addFrom, 'mapShengShiQu', self.mapSheng + '-' + self.mapShi)
          } else {
            self.$set(self.addFrom, 'mapShengShiQu', self.mapSheng + '-' + self.mapShi + '-' + self.mapQu)
          }
          // console.log(self.addFrom.mapShengShiQu, 'mapShengShiQu')
          // console.log(self.addFrom.detailAddress, 'detailAddress')
          self.$set(self.addFrom, 'provinceName', self.mapSheng)
          self.$set(self.addFrom, 'cityName', self.mapShi)
          self.$set(self.addFrom, 'areaName', self.mapQu)
          self.$set(self.addFrom, 'citycode', result.regeocode.addressComponent.citycode)
          self.$set(self.addFrom, 'areaCode', result.regeocode.addressComponent.adcode)
          bAreasList({ parentId: 100000 }).then(res => {
            console.log(res, 'res')
            let arrList = res
            arrList.forEach(item => {
              if (self.mapSheng == item.name) {
                self.provinceCode = item.areaCode
                self.$set(self.addFrom, 'provinceCode', self.provinceCode)
              }
            })
          })
          self.$nextTick()
        }
      } else if (status == 'no_data') {
        this.$alert('没有查到相应地址', '系统提示')
      } else {
        this.$message.error('请输入正确地址')
      }
    }
  },
  watch: {
    addFrom: {
      handler (newName, oldName) {
      },
      deep: true
      // immediate: true
    }
  }
}
</script>
  <style scoped lang='less'>
  /deep/.shengSX .el-input__inner {
      width: 220px;
  }
  /deep/ .bigInp .el-input__inner {
      width: 350px;
  }
  .el-vue-amap-container{
    height:500px;
  }
  .mapBox{
  position: relative;
  }
  .search-box {
      width:210px;
      height: 28px;
      border:solid 1px #ccc;
      position: absolute;
      top: 5px;
      left: 5px;
    }
  </style>
